export enum AreaUnitType {
  SQUARE_METERS = 'SQUARE_METERS',
  SQUARE_FEET = 'SQUARE_FEET',
}
